import {LogLevel} from '@significo/pulse';

const LOG_LEVEL_MAP: Record<string, LogLevel> = {
  trace: LogLevel.Trace,
  debug: LogLevel.Debug,
  info: LogLevel.Info,
  warn: LogLevel.Warn,
  error: LogLevel.Error,
  disable: LogLevel.Off,
};

/** Parses a string log-level name (e.g. "trace", "warn") into the corresponding LogLevel enum value. */
export function parseLogLevel(value: string): LogLevel | null {
  return LOG_LEVEL_MAP[value] ?? null;
}
